import { Blockquote, Amazon, Youtube, Twitter } from '../../../../src/components/blog';
import * as React from 'react';
export default {
  Blockquote,
  Amazon,
  Youtube,
  Twitter,
  React
};